<template>
  <div>
    <v-select
        :items="scenarioListItems"
        v-model="selectedScenarioKey"
        item-text="key"
        item-value="key"
        outlined
        dense
        hide-details
        clearable
    ></v-select>
  </div>
</template>

<script>

/**
 * Component ScenarioList.vue
 *
 * @module ScenarioList
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/Scenario/ScenarioList.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ScenarioList",
  props: {
    subjectId: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      selectedScenarioKey: null,
      scenarioListItems: [
      ],
    };
  },
  created() {
    this.$store.dispatch('scenario/getScenarios').then(scenarios => this.scenarioListItems = scenarios)
  },
  computed: {
    selectedScenario(){
      if (this.selectedScenarioKey){
        for (let i=0; i<this.scenarioListItems.length;i++){
          if (this.scenarioListItems[i].key === this.selectedScenarioKey)
            return this.scenarioListItems[i];
        }
      }

      return null;
    }
  },
  watch: {
    selectedScenarioKey() {
      this.loadPatientScenario();
    },
  },
  methods: {
    async loadPatientScenario() {
      if (this.subjectId && this.selectedScenarioKey){
        if (confirm(
            `This will load the scenario '${this.selectedScenario.key}' into the patient. Any manually changed data will be overridden. Are you sure you want to continue?`
        )){
          const newPatientId = await this.$store.dispatch('scenario/loadScenarioIntoPatient', {
            subjectId : this.subjectId,
            scenarioKey : this.selectedScenarioKey
          });

          if (newPatientId){
            // this.$router.push(`/patient/${newPatientId}`);
            alert(`The scenario '${this.selectedScenario.key}' has been loaded. If you're currently logged in with the mobile application. Please log out and in again.`);
            // Hard reload to avoid cache issues.
            window.location = `/patient/${newPatientId}`
          }
        }else{
          this.selectedScenarioKey = null;
        }
      }
    },
  },
};
</script>